import React from 'react';

import Loader from '~components/loader';
import { SkeletonSimple } from '~components/skeleton';

const ChatSkeleton = () => {
  return (
    <div className="c-chat-page__main">
      <div className="c-chat-page__content c-chat-page__content--loading">
        <Loader />
      </div>
      <div className="c-chat-page__footer">
        <div className="c-chat__form">
          <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-skeleton-simple__chat-input" />
          <SkeletonSimple theme="primary" className="c-skeleton-simple__item c-skeleton-simple__chat-button" />
        </div>
      </div>
    </div>
  );
};

export default ChatSkeleton;
